// extracted by mini-css-extract-plugin
var _1 = "center__KEau8";
var _2 = "header__IzgPa";
var _3 = "left__waBm6";
var _4 = "right__SUOof";
export { _1 as "center", _2 as "header", _3 as "left", _4 as "right" }
